import styled, { css } from "styled-components";

const FormGroupStyled = styled.div`
    position: relative;
    margin: 2rem 0;
    &.half{
        width:50%;
    }
    
    /* focused */
    ${props => {
    return (
      props.focused &&
      css`
          label {
            font-size: 1.2rem;
            top: 1.5rem;
            font-weight: bold;
          }
          input {
            line-height: normal; /* safari fix */
            padding-top: 2rem;
            padding-bottom: 0;
          }
        `
    );
  }}
       
    /* errors */    
    ${props => {
    return (
      props.error &&
      css`
          input,
          select {
            border-color: ${props => props.theme.red};
          }
        `
    );
  }}

    /* disabled */    
    ${props => {
    return (
      props.disabled &&
      css`
          background: ${props => props.theme.lightGrayBorder};
          label {
            font-size: 1.2rem;
            top: 1.5rem;
          }
          input {
            line-height: normal; /* safari fix */
            padding-top: 2.8rem;
          }
        `
    );
  }}

    /* no Top */    
    ${props => {
    return (
      props.noTop &&
      css`
          margin-top: 0;
        `
    );
  }}

  /* no Top Mob */    
    ${props => {
      return (
        props.noTopMob &&
        css`
          margin-top: 0;
          @media only screen and (min-width: 768px) {
            margin-top: 2rem;
          }
        `
      );
    }}
`;

export default FormGroupStyled;
